export default function ErrorDisplay({error}: { error: string | null | undefined }) {
    if (!error) {
        return null;
    } else {
        return (
            <div className="error text-red-500 text-center">{error}</div>
        );
    }
}